<ng-container [formGroup]="metadataFormGroup">
  <app-shared-business-form
    [formGroup]="sharedBusinessFormGroup"
    [showStaffFields]="true"
    [showActivityFields]="true"
  />

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Informations Choses d'Entreprise
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Franchise (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="reimbursedSum"
      />
    </div>
    <div class="col">
      <label i18n>Somme d'assurance (CHF)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>Objets assurés</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="
            getControl(metadataFormGroup.controls['insuredObjects'])
          "
          multiple
        >
          <mat-option
            *ngFor="let object of insuredObjectValues"
            [value]="object"
          >
            {{ getBusinessInsuredObjectLabel(object) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row my-3" *ngIf="hasOtherSelected()">
    <div class="col">
      <label i18n>Autre objet</label>
      <input type="text" class="form-control" formControlName="otherObject" />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Incendie
  </div>
  <ng-container formGroupName="fireDamageCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Incendie et événements naturels</label>
        <div class="form-check">
          <input
            type="radio"
            name="fireNaturalDisasterCoverage"
            id="fireNaturalDisasterCoverageFalse"
            [value]="false"
            formControlName="fireNaturalDisasterCoverage"
          />
          <label class="form-check-label" for="fireNaturalDisasterCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="fireNaturalDisasterCoverage"
            id="fireNaturalDisasterCoverageTrue"
            [value]="true"
            formControlName="fireNaturalDisasterCoverage"
          />
          <label class="form-check-label" for="fireNaturalDisasterCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get(
            'fireDamageCoverage.fireNaturalDisasterCoverage'
          )?.value === 'true' ||
          metadataFormGroup.get(
            'fireDamageCoverage.fireNaturalDisasterCoverage'
          )?.value === true
        "
      >
        <label i18n>Couverture DIC/DIL</label>
        <div class="form-check">
          <input
            type="radio"
            name="dicDilCoverage"
            id="dicDilCoverageFalse"
            [value]="false"
            formControlName="dicDilCoverage"
          />
          <label class="form-check-label" for="dicDilCoverageFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="dicDilCoverage"
            id="dicDilCoverageTrue"
            [value]="true"
            formControlName="dicDilCoverage"
          />
          <label class="form-check-label" for="dicDilCoverageTrue">Oui</label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Valeur</label>
        <mat-form-field class="lty-input">
          <mat-select formControlName="value">
            <mat-option *ngFor="let value of thingValueValues" [value]="value">
              {{ getBusinessCompanyThingValueLabel(value) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Franchise en incendie</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="fireDeductible"
        />
      </div>
      <div class="col">
        <label i18n>Choses spéciales et frais</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="specialFees"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Assurance prévisionnelle</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="contingencyInsurance"
        />
      </div>
      <div class="col">
        <label i18n>Assurance externe</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="externalInsurance"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Outils dans baraques de chantier</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="constructionHutTools"
        />
      </div>
      <div class="col">
        <label i18n>Troubles intérieurs / E.C.</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="internalDisturbances"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Franchise en E.C.</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="internalDistrubancesDeductible"
        />
      </div>
      <div class="col">
        <label i18n>Valeurs pécuniaires</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="monetaryValues"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('fireDamageCoverage.fireNaturalDisasterCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Valeurs pécuniaires dans les coffres-forts</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="monetaryValuesInSafe"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Tremblement de terre
  </div>
  <div
    formGroupName="earthquakeCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
  >
    <div class="col">
      <label i18n>Couverture tremblement de terre</label>
      <div class="form-check">
        <input
          type="radio"
          id="earthquakeCoverageFalse"
          [value]="false"
          formControlName="coverage"
        />
        <label class="form-check-label" for="earthquakeCoverageFalse"
          >Non</label
        >
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="earthquakeCoverageTrue"
          [value]="true"
          formControlName="coverage"
        />
        <label class="form-check-label" for="earthquakeCoverageTrue">Oui</label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.get('earthquakeCoverage.coverage')?.value ===
          'true' ||
        metadataFormGroup.get('earthquakeCoverage.coverage')?.value === true
      "
    >
      <label i18n>Valeur</label>
      <mat-form-field class="lty-input">
        <mat-select formControlName="value">
          <mat-option *ngFor="let value of thingValueValues" [value]="value">
            {{ getBusinessCompanyThingValueLabel(value) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div
    formGroupName="earthquakeCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
    *ngIf="
      metadataFormGroup.get('earthquakeCoverage.coverage')?.value === 'true' ||
      metadataFormGroup.get('earthquakeCoverage.coverage')?.value === true
    "
  >
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductible"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Terrorisme
  </div>
  <div
    formGroupName="terrorismCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
  >
    <div class="col">
      <label i18n>Couverture terrorisme</label>
      <div class="form-check">
        <input
          type="radio"
          id="terrorismCoverageFalse"
          [value]="false"
          formControlName="coverage"
        />
        <label class="form-check-label" for="terrorismCoverageFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="terrorismCoverageTrue"
          [value]="true"
          formControlName="coverage"
        />
        <label class="form-check-label" for="terrorismCoverageTrue">Oui</label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.get('terrorismCoverage.coverage')?.value === 'true' ||
        metadataFormGroup.get('terrorismCoverage.coverage')?.value === true
      "
    >
      <label i18n>Valeur</label>
      <mat-form-field class="lty-input">
        <mat-select formControlName="value">
          <mat-option *ngFor="let value of thingValueValues" [value]="value">
            {{ getBusinessCompanyThingValueLabel(value) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div
    formGroupName="terrorismCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
    *ngIf="
      metadataFormGroup.get('terrorismCoverage.coverage')?.value === 'true' ||
      metadataFormGroup.get('terrorismCoverage.coverage')?.value === true
    "
  >
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductible"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>Vol</div>
  <ng-container formGroupName="theftCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Vol avec effraction et détournement</label>
        <div class="form-check">
          <input
            type="radio"
            name="theftCoverage"
            id="theftCoverageFalse"
            [value]="false"
            formControlName="theftCoverage"
          />
          <label class="form-check-label" for="theftCoverageFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="theftCoverage"
            id="theftCoverageTrue"
            [value]="true"
            formControlName="theftCoverage"
          />
          <label class="form-check-label" for="theftCoverageTrue">Oui</label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Valeur</label>
        <mat-form-field class="lty-input">
          <mat-select formControlName="value">
            <mat-option *ngFor="let value of thingValueValues" [value]="value">
              {{ getBusinessCompanyThingValueLabel(value) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
      <div class="col">
        <label i18n>Choses spéciales et frais</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="specialFees"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Assurance prévisionnelle</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="contingencyInsurance"
        />
      </div>
      <div class="col">
        <label i18n>Assurance externe</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="externalInsurance"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Outils dans baraques de chantier</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="constructionHutTools"
        />
      </div>
      <div class="col">
        <label i18n>Valeurs pécuniaires</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="monetaryValues"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('theftCoverage.theftCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Valeurs pécuniaires dans les coffres-forts</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="monetaryValuesInSafe"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Bris de glace
  </div>
  <div
    formGroupName="breakageCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
  >
    <div class="col">
      <label i18n>Couverture bris de glace</label>
      <div class="form-check">
        <input
          type="radio"
          id="breakageCoverageFalse"
          [value]="false"
          formControlName="coverage"
        />
        <label class="form-check-label" for="breakageCoverageFalse">Non</label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          id="breakageCoverageTrue"
          [value]="true"
          formControlName="coverage"
        />
        <label class="form-check-label" for="breakageCoverageTrue">Oui</label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.get('breakageCoverage.coverage')?.value === 'true' ||
        metadataFormGroup.get('breakageCoverage.coverage')?.value === true
      "
    >
      <label i18n>Valeur</label>
      <mat-form-field class="lty-input">
        <mat-select formControlName="value">
          <mat-option *ngFor="let value of thingValueValues" [value]="value">
            {{ getBusinessCompanyThingValueLabel(value) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div
    formGroupName="breakageCoverage"
    class="row row-cols-md-2 row-cols-sm-1 my-3"
    *ngIf="
      metadataFormGroup.get('breakageCoverage.coverage')?.value === 'true' ||
      metadataFormGroup.get('breakageCoverage.coverage')?.value === true
    "
  >
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuredSum"
      />
    </div>
    <div class="col">
      <label i18n>Franchise</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="deductible"
      />
    </div>
  </div>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Dégâts des eaux
  </div>
  <ng-container formGroupName="waterDamageCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Dégâts des eaux</label>
        <div class="form-check">
          <input
            type="radio"
            name="waterDamageCoverage"
            id="waterDamageCoverageFalse"
            [value]="false"
            formControlName="waterDamageCoverage"
          />
          <label class="form-check-label" for="waterDamageCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="waterDamageCoverage"
            id="waterDamageCoverageTrue"
            [value]="true"
            formControlName="waterDamageCoverage"
          />
          <label class="form-check-label" for="waterDamageCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Valeur</label>
        <mat-form-field class="lty-input">
          <mat-select formControlName="value">
            <mat-option *ngFor="let value of thingValueValues" [value]="value">
              {{ getBusinessCompanyThingValueLabel(value) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Franchise</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
      <div class="col">
        <label i18n>Choses spéciales et frais</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="specialFees"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Assurance prévisionnelle</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="contingencyInsurance"
        />
      </div>
      <div class="col">
        <label i18n>Assurance externe</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="externalInsurance"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === 'true' ||
        metadataFormGroup.get('waterDamageCoverage.waterDamageCoverage')
          ?.value === true
      "
    >
      <div class="col">
        <label i18n>Outils dans baraques de chantier</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="constructionHutTools"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Épidémie
  </div>
  <ng-container formGroupName="epidemicCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Pandémie incluse</label>
        <div class="form-check">
          <input
            type="radio"
            name="pandemicIncluded"
            id="pandemicIncludedFalse"
            [value]="false"
            formControlName="pandemicIncluded"
          />
          <label class="form-check-label" for="pandemicIncludedFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="pandemicIncluded"
            id="pandemicIncludedTrue"
            [value]="true"
            formControlName="pandemicIncluded"
          />
          <label class="form-check-label" for="pandemicIncludedTrue">Oui</label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('epidemicCoverage.pandemicIncluded')?.value ===
          'true' ||
        metadataFormGroup.get('epidemicCoverage.pandemicIncluded')?.value ===
          true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Franchise (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-1 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('epidemicCoverage.pandemicIncluded')?.value ===
          'true' ||
        metadataFormGroup.get('epidemicCoverage.pandemicIncluded')?.value ===
          true
      "
    >
      <div class="col">
        <label i18n>Durée</label>
        <input type="text" class="form-control" formControlName="duration" />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Couverture Technique
  </div>
  <ng-container formGroupName="technicalCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Couverture technique</label>
        <div class="form-check">
          <input
            type="radio"
            name="technicalCoverage"
            id="technicalCoverageFalse"
            [value]="false"
            formControlName="technicalCoverage"
          />
          <label class="form-check-label" for="technicalCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="technicalCoverage"
            id="technicalCoverageTrue"
            [value]="true"
            formControlName="technicalCoverage"
          />
          <label class="form-check-label" for="technicalCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('technicalCoverage.technicalCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('technicalCoverage.technicalCoverage')?.value ===
          true
      "
    >
      <div class="col">
        <label i18n>Somme d'assurance (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="insuredSum"
        />
      </div>
      <div class="col">
        <label i18n>Franchise (CHF)</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="deductible"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-1 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('technicalCoverage.technicalCoverage')?.value ===
          'true' ||
        metadataFormGroup.get('technicalCoverage.technicalCoverage')?.value ===
          true
      "
    >
      <div class="col">
        <label i18n>Type d'assurance</label>
        <input
          type="text"
          class="form-control"
          formControlName="insuranceType"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Pertes d'Exploitation
  </div>
  <ng-container formGroupName="lossCoverage">
    <div class="row row-cols-md-2 row-cols-sm-1 my-3">
      <div class="col">
        <label i18n>Pertes d'exploitation</label>
        <div class="form-check">
          <input
            type="radio"
            name="lossCoverage"
            id="lossCoverageFalse"
            [value]="false"
            formControlName="lossCoverage"
          />
          <label class="form-check-label" for="lossCoverageFalse">Non</label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="lossCoverage"
            id="lossCoverageTrue"
            [value]="true"
            formControlName="lossCoverage"
          />
          <label class="form-check-label" for="lossCoverageTrue">Oui</label>
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Incendie et événements naturels</label>
        <div class="form-check">
          <input
            type="radio"
            id="lossFireNaturalDisasterCoverageFalse"
            [value]="false"
            formControlName="fireNaturalDisasterCoverage"
          />
          <label
            class="form-check-label"
            for="lossFireNaturalDisasterCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="lossFireNaturalDisasterCoverageTrue"
            [value]="true"
            formControlName="fireNaturalDisasterCoverage"
          />
          <label
            class="form-check-label"
            for="lossFireNaturalDisasterCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.fireNaturalDisasterCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('lossCoverage.fireNaturalDisasterCoverage')
            ?.value === true
        "
      >
        <label i18n>Somme d'assurance incendie</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="fireInsuredSum"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.fireNaturalDisasterCoverage')
            ?.value === 'true' ||
          metadataFormGroup.get('lossCoverage.fireNaturalDisasterCoverage')
            ?.value === true
        "
      >
        <label i18n>Franchise incendie</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="fireDeductible"
        />
      </div>
      <div class="col">
        <label i18n>Vol avec effraction et détournement</label>
        <div class="form-check">
          <input
            type="radio"
            id="lossTheftCoverageFalse"
            [value]="false"
            formControlName="theftCoverage"
          />
          <label class="form-check-label" for="lossTheftCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="lossTheftCoverageTrue"
            [value]="true"
            formControlName="theftCoverage"
          />
          <label class="form-check-label" for="lossTheftCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.theftCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('lossCoverage.theftCoverage')?.value === true
        "
      >
        <label i18n>Somme d'assurance vol</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="theftInsuredSum"
        />
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.theftCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('lossCoverage.theftCoverage')?.value === true
        "
      >
        <label i18n>Franchise vol</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="theftDeductible"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Dégâts des eaux</label>
        <div class="form-check">
          <input
            type="radio"
            id="lossWaterDamageCoverageFalse"
            [value]="false"
            formControlName="waterDamageCoverage"
          />
          <label class="form-check-label" for="lossWaterDamageCoverageFalse"
            >Non</label
          >
        </div>
        <div class="form-check">
          <input
            type="radio"
            id="lossWaterDamageCoverageTrue"
            [value]="true"
            formControlName="waterDamageCoverage"
          />
          <label class="form-check-label" for="lossWaterDamageCoverageTrue"
            >Oui</label
          >
        </div>
      </div>
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.waterDamageCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('lossCoverage.waterDamageCoverage')?.value ===
            true
        "
      >
        <label i18n>Somme d'assurance dégâts des eaux</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="waterInsuredSum"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div
        class="col"
        *ngIf="
          metadataFormGroup.get('lossCoverage.waterDamageCoverage')?.value ===
            'true' ||
          metadataFormGroup.get('lossCoverage.waterDamageCoverage')?.value ===
            true
        "
      >
        <label i18n>Franchise dégâts des eaux</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="waterDeductible"
        />
      </div>
      <div class="col">
        <label i18n>Chiffre d'affaires</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="revenue"
        />
      </div>
    </div>

    <div
      class="row row-cols-md-2 row-cols-sm-1 my-3"
      *ngIf="
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === 'true' ||
        metadataFormGroup.get('lossCoverage.lossCoverage')?.value === true
      "
    >
      <div class="col">
        <label i18n>Bénéfice brut d'assurance</label>
        <input
          type="number"
          min="0"
          class="form-control"
          formControlName="grossInsuranceProfit"
        />
      </div>
    </div>
  </ng-container>

  <div class="form-subtitle flex-basis-100 mb-16 text-16 mt-32" i18n>
    Assurance actuelle
  </div>

  <div class="row row-cols-md-2 row-cols-sm-1 my-3">
    <div class="col">
      <label i18n>Possède une assurance</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceFalse"
          [value]="false"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsurance"
          id="hasInsuranceTrue"
          [value]="true"
          formControlName="hasInsurance"
        />
        <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
      </div>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.hasInsurance === 'true' ||
        metadataFormGroup.value.hasInsurance === true
      "
    >
      <label i18n>Assureur actuel</label>
      <input
        type="text"
        class="form-control"
        formControlName="currentInsurer"
      />
    </div>
  </div>

  <div class="row my-3">
    <div class="col">
      <label i18n>A subi des sinistres ces 5 dernières années</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsFalse"
          [value]="false"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasClaimsLastFiveYears"
          id="hasClaimsLastFiveYearsTrue"
          [value]="true"
          formControlName="hasClaimsLastFiveYears"
        />
        <label class="form-check-label" for="hasClaimsLastFiveYearsTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
